import { useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import { LanguageLoader } from '../../assets/languages';
import {useSelector} from "react-redux";

// Nested sidebar item component for handling children
const NestedSidebarItem = ({ child, item, language }) => {
	const [childIsOpen, setChildOpen] = useState(false);
	const settings = useSelector((state) => state.settings);
	const location = useLocation();
	
	const childTitle = child.title.toUpperCase();
	const childLabel = language.MENU[childTitle] ? language.MENU[childTitle] : child.title;
	
	const grandChildren = Object.values(child.children).map((grandChild, grandIndex) => {
		if (!grandChild.path) return null;
		
		const grandModuleName = grandChild.path.replace('/edit/', '').replace('/list/', '').replace('/dynamic/', '');
		if(settings.definitions.modules[grandModuleName] || item.component === 'Dynamic')
		{
			const grandDefinition = settings.definitions.modules[grandModuleName];
			if(grandDefinition && ((grandChild.path.indexOf('/edit/') > -1 && !grandDefinition.access.create) || (grandChild.path.indexOf('/list/') > -1 && !grandDefinition.access.list)))
			{
				return null;
			}
			return <li key={grandIndex} className={grandChild.path === location.pathname ? 'selected' : ''}><Link to={grandChild.path}><i className={"mx-2 "+grandChild.icon}></i><span>{language.MENU[grandChild.title.toUpperCase()] ? language.MENU[grandChild.title.toUpperCase()] : grandChild.title}</span></Link></li>
		}
		else if(item.component === 'Dynamic')
		{
			return <li key={grandIndex} className={grandChild.path === location.pathname ? 'selected' : ''}><Link to={grandChild.path}><i className={"mx-2 "+grandChild.icon}></i><span>{language.MENU[grandChild.title.toUpperCase()] ? language.MENU[grandChild.title.toUpperCase()] : grandChild.title}</span></Link></li>
		}
		return null;
	});
	
	return (grandChildren.filter(item => item).length) ? (
		<li>
			<div className={childIsOpen ? "open" : ""}>
				<span onClick={() => setChildOpen(!childIsOpen)}>
					<i className={child.icon}></i>
					<span className="mx-2">{childLabel}</span>
					<i className='fa fa-chevron-down text-xs mr-auto'></i>
				</span>
				<ul>
					{grandChildren.filter(item => item)}
				</ul>
			</div>
		</li>
	) : null;
};

const SidebarItem = (item) => {
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [isOpen, SetOpen] = useState(false);
	const location = useLocation();
	if(item.children && item.children.length)
	{

		let title = item.title.toUpperCase();
		let label = language.MENU[title] ? language.MENU[title] : item.title;
		let childItems = Object.values(item.children).map((child, childIndex) =>
		{
			/* CHECKING ACCESS */
			// If child has children (nested), render using NestedSidebarItem component
			if(child.children && child.children.length) {
				return <NestedSidebarItem key={childIndex} child={child} item={item} language={language} />
			}
			
			// Check if child has a path before trying to access it
			if (!child.path) {
				return null;
			}
			
			const moduleName = child.path.replace('/edit/', '').replace('/list/', '').replace('/dynamic/', '');
			if(settings.definitions.modules[moduleName] || item.component === 'Dynamic')
			{
				const definition = settings.definitions.modules[moduleName];
				if(definition && ((child.path.indexOf('/edit/') > -1 && !definition.access.create) || (child.path.indexOf('/list/') > -1 && !definition.access.list)))
				{
					return null;
				}
				return <li key={childIndex} className={child.path === location.pathname ? 'selected' : ''}><Link to={child.path}><i className={"mx-2 "+child.icon}></i><span>{language.MENU[child.title.toUpperCase()] ? (language.MENU[child.title.toUpperCase()] + ' ' + label) : child.title}</span></Link></li>
			}
			else if(item.component === 'Dynamic')
			{
				// For dynamic routes, always show the child item
				return <li key={childIndex} className={child.path === location.pathname ? 'selected' : ''}><Link to={child.path}><i className={"mx-2 "+child.icon}></i><span>{language.MENU[child.title.toUpperCase()] ? (language.MENU[child.title.toUpperCase()] + ' ' + label) : child.title}</span></Link></li>
			}
			return null;
		});
		return (childItems.filter(item => item).length) ? <div className={isOpen ? "open" : null}>
			<span onClick={() => SetOpen(!isOpen)}>
				<i className={item.icon}></i>
				<span className="mx-2">{label}</span>
				<i className='fa fa-chevron-down text-xs mr-auto'></i>
			</span>
			<ul>
				{childItems.filter(item => item)}
			</ul>
		</div> : null;
	}
	else
	{
		let label = language.MENU[item.title.toUpperCase()] ? language.MENU[item.title.toUpperCase()] : item.title;
		return (
			<div className={item.path === location.pathname ? 'selected' : ''}>
				<Link to={item.path}>
					<i className={item.icon}></i><span className="mx-2">{label}</span>
				</Link>
			</div>
		);
	}
}

export default SidebarItem;